export const DISABLED_OPACITY = 0.4
